import React from "react";
import CETDashboard from "../../components/CETDashBoard/CETDashboard";
const CETDashboardContainers = () => {
  return <CETDashboard />;
};

export default CETDashboardContainers;
